/* Main PDP slide-in behavior, shared by both conversion-page panels. */
(() => {
  const init = () => {
    document.querySelectorAll('dialog[data-moses-test-dialog]').forEach(dialog => {
      if (dialog.dataset.initialized) return;
      dialog.dataset.initialized = 'true';
      let trigger;
      let previousOverflow;
      let motion;
      let closing = false;
      const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const restore = () => {
        motion?.cancel();
        closing = false;
        dialog.classList.remove('is-closing');
        document.documentElement.style.overflow = previousOverflow || '';
        trigger?.focus({ preventScroll: true });
      };
      const close = () => {
        if (!dialog.open || closing) return;
        closing = true;
        const from = getComputedStyle(dialog).transform;
        motion?.cancel();
        if (reducedMotion()) { dialog.close(); return; }
        dialog.classList.add('is-closing');
        motion = dialog.animate([{ transform: from }, { transform: 'translateX(-100%)' }], {
          duration: 280, easing: 'cubic-bezier(.4,0,1,1)', fill: 'forwards'
        });
        motion.finished.then(() => dialog.close()).catch(() => {});
      };
      document.querySelectorAll(`[data-moses-test-dialog-open="${dialog.id}"]`).forEach(button => {
        button.addEventListener('click', () => {
          if (dialog.open) return;
          trigger = button;
          previousOverflow = document.documentElement.style.overflow;
          dialog.showModal();
          dialog.querySelector('.moses-test-dialog-header h2').focus({ preventScroll: true });
          document.documentElement.style.overflow = 'hidden';
          dialog.querySelector('.moses-test-dialog-body').scrollTop = 0;
          if (!reducedMotion()) motion = dialog.animate([
            { transform: 'translateX(-100%)' }, { transform: 'translateX(0)' }
          ], { duration: 400, easing: 'cubic-bezier(.22,1,.36,1)' });
        });
      });
      dialog.querySelector('[data-moses-test-dialog-close]').addEventListener('click', close);
      dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
      dialog.addEventListener('close', restore);
      dialog.addEventListener('keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); close(); return; }
        if (event.key !== 'Tab') return;
        const focusable = Array.from(dialog.querySelectorAll('button, a[href], [tabindex]'))
          .filter(element => !element.disabled && element.tabIndex >= 0 && element.getClientRects().length);
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && (document.activeElement === first || document.activeElement === dialog.querySelector('.moses-test-dialog-header h2'))) {
          event.preventDefault(); last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault(); first.focus();
        }
      });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const r = dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close();
      });
      const tabs = Array.from(dialog.querySelectorAll('[role="tab"]'));
      const activate = tab => tabs.forEach(button => {
        const selected = button === tab;
        button.setAttribute('aria-selected', String(selected));
        button.tabIndex = selected ? 0 : -1;
        dialog.querySelector(`#${button.getAttribute('aria-controls')}`).hidden = !selected;
      });
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else return;
          event.preventDefault(); activate(tabs[next]); tabs[next].focus();
        });
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
